<template>
  <v-app>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ `login.dialog.${dialogkey}.title` | t }}</v-card-title>
        <v-card-text>{{ `login.dialog.${dialogkey}.text` | t }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            flat="flat"
            @click.native="dialog = false"
          >{{ `login.dialog.${dialogkey}.confirm` | t }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-content>
      <v-container fluid>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-card-title primary-title>
              <v-flex xs12>
                <h3 class="headline mb-0">{{ 'login.title' | t }}</h3>
                <v-flex xs12>
                  <v-form v-model="valid" ref="form">
                    <v-text-field
                      :label="$t('login.mail')"
                      v-model="mail"
                      prepend-icon="mail"
                      required
                    ></v-text-field>
                    <v-text-field
                      :label="$t('login.password')"
                      v-model="password"
                      type="password"
                      prepend-icon="lock"
                      required
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-flex>
            </v-card-title>
            <v-card-actions>
              <vue-recaptcha
                sitekey="6LdaG0IUAAAAAMNWSJdbGJc-D-CQlZQpRKd3tHb0"
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired"
              ></vue-recaptcha>
            </v-card-actions>
            <v-card-actions>
              <v-btn
                @click="login"
                :disabled="nocaptcha"
                :loading="loading"
                color="primary white--text"
              >{{ 'login.button.confirm' | t }}</v-btn>
              <v-spacer />
              <v-btn flat small to="/forgot">{{ 'login.button.forgot' | t }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import md5 from "md5";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      dialogkey: "notfound",
      dialog: false,
      valid: true,
      nocaptcha: true,
      loading: false,
      verify: "",
      mail: "",
      password: ""
    };
  },
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
  computed: {
    ...mapGetters(["getServer"])
  },
  methods: {
    ...mapActions(["setSession", "setLanguage"]),
    onVerify(response) {
      this.verify = response;
      this.nocaptcha = false;
    },
    onExpired() {
      this.nocaptcha = true;
    },
    async login() {
      const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      this.loading = true;

      if (
        [undefined, null, ""].includes(this.mail) ||
        [undefined, null, ""].includes(this.password) ||
        this.mail.length < 6 ||
        this.password.length < 8 ||
        !reg.test(this.mail)
      ) {
        this.$refs.recaptcha.reset();
        this.nocaptcha = true;
        this.dialogkey = "notfound";
        this.mail = "";
        this.password = "";
        this.dialog = true;
        this.loading = false;
        this.$refs.form.reset();
      } else {
        try {
          const res = await this.$http.post(`${this.getServer}/login`, {
            mail: this.mail.toLowerCase(),
            password: md5(this.password),
            verify: this.verify
          });

          this.loading = false;
          if (res.data.token && res.data.userid) {
            const key = res.data.token;
            const userid = res.data.userid;
            const admin = res.data.admin;
            const user_type = res.data.user_type;
            if (res.data.language) {
              this.$i18n.locale = res.data.language;
              localStorage.setItem("language", res.data.language);
            }

            this.setSession({
              key,
              userid,
              admin,
              user_type
            });
          } else {
            this.$refs.recaptcha.reset();
            this.nocaptcha = true;
            this.dialogkey = "notfound";
            this.mail = "";
            this.password = "";
            this.dialog = true;
            this.loading = false;
            this.$refs.form.reset();
          }
        } catch (error) {
          this.loading = false;
          this.$refs.recaptcha.reset();
          this.nocaptcha = true;
          this.dialogkey = "problems";
          this.dialog = true;
          this.$refs.form.reset();
        }
      }
    }
  }
};
</script>